module.exports = __webpack_public_path__ + "626a8df770fad0e5b6aaaccb21db81c2.svg";